import { cn } from "@quint/ui";
import { ChevronRight } from "lucide-react";
import { type StakingCardDatum } from "./types";
import { isValidElement } from "react";

export type StakingCardDesktopProps = StakingCardDatum & {
  selected: boolean;
  setSelected: (s: StakingCardDatum) => void;
};
export const StakingCardDesktop = (props: StakingCardDesktopProps) => {
  const { deprecated, Icon, name, selected, setSelected, rewards, harvestButton } = props;
  return (
    <button
      onClick={() => setSelected(props)}
      className={cn(
        "p-8",
        "rounded-2xl",
        "min-h-[122px]",
        "border-[1px] border-solid border-[#E6E8EA] dark:border-[#354856]",
        "flex items-center justify-between",
        {
          "border-[#22C994] bg-[#C9EDE0] dark:bg-[#16464B]": selected,
        }
      )}
    >
      <div className="flex gap-6">
        <Icon />
        <div>
          <p className={cn(deprecated && "line-through", "text-left")}>{name}</p>
          <div className="flex gap-4">
            <p className="text-slate-700 dark:text-slate-300">REWARDS</p>
            <p>{isValidElement(rewards) ? rewards : null}</p>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {isValidElement(harvestButton) ? harvestButton : null}
        <ChevronRight />
      </div>
    </button>
  );
};
